import { render, staticRenderFns } from "./EntriesEvolution.vue?vue&type=template&id=70515602"
import script from "./EntriesEvolution.vue?vue&type=script&lang=js"
export * from "./EntriesEvolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports